import { ROUTES } from "@app/constants";
import { IPayoutInfluencer } from "@shared/lib/types/briefCampains";
import { ColumnType } from "antd/es/table";
import { Link } from "react-router-dom";
import { PayoutCampaignColumnFilter } from "../ui/PayoutCampaignColumnFilter";
import styles from "./usePayoutsColumns.module.scss";

type BriefOption = {
  label: string;
  value: string;
};

type GetPayoutCampaignColumnParams = {
  briefOptions: BriefOption[];
  selectedBriefIds: string[];
  onBriefIdsChange: (ids: string[]) => void;
  briefSearch: string;
  onBriefSearchChange: (value: string) => void;
  areBriefsLoading: boolean;
};

export function getPayoutCampaignColumn({
  briefOptions,
  selectedBriefIds,
  onBriefIdsChange,
  briefSearch,
  onBriefSearchChange,
  areBriefsLoading,
}: GetPayoutCampaignColumnParams): ColumnType<IPayoutInfluencer> {
  return {
    title: "Campaign",
    key: "campaign",
    width: 180,
    filterCount: selectedBriefIds.length,
    filtered: selectedBriefIds.length > 0,
    filterDropdownProps: {
      destroyPopupOnHide: true,
    },
    filterDropdown: (props: { confirm: () => void; close: () => void }) => (
      <PayoutCampaignColumnFilter
        confirm={props.confirm}
        close={props.close}
        options={briefOptions}
        selectedBriefIds={selectedBriefIds}
        onApply={onBriefIdsChange}
        briefSearch={briefSearch}
        onBriefSearchChange={onBriefSearchChange}
        isLoading={areBriefsLoading}
      />
    ),
    render: (_value: unknown, record: IPayoutInfluencer) => {
      const briefId = record.campaignInfluencer?.brief?._id || record.briefId;
      const name = record.campaignInfluencer?.brief?.name || "—";
      if (!briefId) {
        return <span className={styles.campaignLink}>{name}</span>;
      }
      return (
        <Link
          className={styles.campaignLink}
          to={ROUTES.BRIEF_V2_CAMPAIGNS.replace(":briefId", briefId)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {name}
        </Link>
      );
    },
  };
}
